module.exports = __webpack_public_path__ + "assets/chart_graph_light.png";